import { HTTP } from '../../http-common'

export default {
  state: {
    loadedCities: []
  },
  getters: {
    loadedCities (state) {
      return state.loadedCities
    }
  },
  mutations: {
    setLoadedCities (state, payload) {
      state.loadedCities = payload
    },
    createCity (state, payload) {
      state.loadedCities.push(payload)
    },
    updateCity (state, payload) {
      state.loadedCities = state.loadedCities.map(city => city.id === payload.id ? payload : city)
    },
    removeCity (state, id) {
      state.loadedCities = state.loadedCities.filter(city => {
        return city.id !== id
      })
    },
    clearLoadedCities (state) {
      state.loadedCities = []
    }
  },
  actions: {
    loadCities ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedCities', [])

      return new Promise((resolve, reject) => {
        HTTP.get('city.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedCities', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createCity ({ commit, getters }, payload) {
      console.log('createCity')
      commit('clearError')
      commit('setLoading', true)
      const newCity = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('city.json/', newCity)
          .then(result => {
            console.log(result)
            commit('createCity', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateCity ({ commit, getters }, payload) {
      console.log('updateCity')
      commit('clearError')
      commit('setLoading', true)
      const city = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`city.json/${payload.id}/`, city)
          .then(result => {
            console.log(result)
            commit('updateCity', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeCity ({ commit }, payload) {
      console.log('removeCity')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`city.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeCity', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedCities ({ commit }) {
      commit('clearLoadedCities')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/city/index.js